import {AbstractDeleteOneService} from '../../../../core/service/v2/service/delete/abstractDeleteOne.service';
import {ChargedActModel} from '../../api/entity/chargedAct.model';
import {Injectable} from '@angular/core';
import {ChargedActRepository} from './ngrx/chargedAct.repository';
import {ChargedActDataServiceAdapter} from './ngrx/chargedActDataService.adapter';
import {
    PurchaseOrderRepository
} from '../../../../sale/modules/purchase_order/impl/service/ngrx/purchaseOrder.repository';
import {SaleInvoiceRepository} from '../../../../sale/modules/invoice/impl/service/ngrx/saleInvoice.repository';
import {PaymentRequestRepository} from '../../../../sale/modules/payment_request/impl/service/ngrx/PaymentRequest.repository';

@Injectable()
export class ChargedActDeleteService extends AbstractDeleteOneService<ChargedActModel, ChargedActModel> {
    constructor(repository: ChargedActRepository,
                dataServiceAdapter: ChargedActDataServiceAdapter,
                private paymentRequestRepository: PaymentRequestRepository,
                private saleInvoiceService: SaleInvoiceRepository,
                private purchaseOrderRepository: PurchaseOrderRepository) {
        super(repository, dataServiceAdapter);
    }

    protected postDelete(storedEntity: ChargedActModel): void {
        this.paymentRequestRepository.clearCache();
        this.saleInvoiceService.clearCache();
        this.purchaseOrderRepository.clearCache();
    }
}
